import Vue from 'vue'
import Router from 'vue-router'

//-- Components
	import Authentication from '../components/authentication/layout/Authentication.vue'
	import Login from '../components/authentication/views/Login.vue'
	import Logout from '../components/authentication/views/Logout.vue'
	import Forget from '../components/authentication/views/Forget.vue'
	import Reset from '../components/authentication/views/Reset.vue'

	import Dashboard from '../components/dashboard/layout/Dashboard.vue'

	import Admin from '../components/Admin.vue'

	import Settings from '../components/settings/layout/Settings.vue'
	import SettingsIndex from '../components/settings/views/Index.vue'
	import PaymentConditions from '../components/management/paymentConditions/layout/PaymentConditions.vue'
	import PaymentConditionsIndex from '../components/management/paymentConditions/views/Index.vue'

	import qrCodeReader from '../components/qrCodeReader/layout/qrCodeReader.vue'

	//-- Users
		import Users from '../components/users/layout/Users.vue'
		import UsersIndex from '../components/users/views/Index.vue'
		import UsersCreate from '../components/users/views/Create.vue'
		import UsersEdit from '../components/users/views/Edit.vue'
		import UsersShow from '../components/users/views/Show.vue'

	//-- Requests
		import Requests from '../components/requests/layout/Requests.vue'
		import RequestsIndex from '../components/requests/views/Index.vue'

	//-- Customers
		import Customers from '../components/customers/layout/Customers.vue'
		import CustomersIndex from '../components/customers/views/Index.vue'
		import CustomersCreate from '../components/customers/views/Create.vue'
		import CustomersEdit from '../components/customers/views/Edit.vue'
		import CustomersShow from '../components/customers/views/Show.vue'
		import CustomersDocs from '../components/customers/views/Docs.vue'
		import CustomersRequests from '../components/customers/views/Requests.vue'

		//-- Customers Accounts
			import CustomersAccounts from '../components/customers/views/CollectionAccounts.vue'
		//-- Customers Budgets
			import CustomersBudgets from '../components/customers/views/Budgets.vue'
		//-- Customers Orders
			import CustomersOrders from '../components/customers/views/Orders.vue'
		//-- Customers Invoices
			import CustomersInvoices from '../components/customers/views/Invoices.vue'
		//-- Customers Projects
			import CustomersProjects from '../components/customers/views/Projects.vue'
		//-- Customers Agreements
			import CustomersAgreements from '../components/customers/views/Agreements.vue'
		//-- Customers Viewer
			import CustomersViewer from '../components/customers/views/Viewer.vue'

	//-- Agreement
		import Agreement from '../components/agreements/layout/Agreement.vue'
		import AgreementIndex from '../components/agreements/views/Index.vue'
		import AgreementEdit from '../components/agreements/views/Edit.vue'
		import AgreementShow from '../components/agreements/views/Show.vue'

		//-- Recurring
			import Recurrings from '../components/agreements/components/recurrings/layout/Recurrings.vue'

	//-- Notifications
		import Notifications from '../components/notifications/layout/Notifications.vue'
		import NotificationsIndex from '../components/notifications/views/Index.vue'

	//-- Departments
		import Departments from '../components/departments/layout/Departments.vue'
		import DepartmentsIndex from '../components/departments/views/Index.vue'

	//-- GOWIX PROJECTS COMPONENTS
		import ProjectsPackage from '../components/projects/ProjectsPackage.vue'
		import DashboardProjects from '../components/projects/dashboard/layout/Dashboard.vue'

		//-- Calendar
			import Calendar from '../components/projects/calendar/layout/Calendar.vue'
			import CalendarIndex from '../components/projects/calendar/views/Index.vue'

		//-- Tasks
			import Tasks from '../components/projects/tasks/layout/Task.vue'
			import TasksIndex from '../components/projects/tasks/views/Index.vue'
			import TasksCreate from '../components/projects/tasks/views/Create.vue'
			import TasksEdit from '../components/projects/tasks/views/Edit.vue'
			import TasksShow from '../components/projects/tasks/views/Show.vue'

		//-- Reports
			import ProjectsReports from '../components/projects/reports/layout/Reports.vue'

		//-- Projects
			import Projects from '../components/projects/projects/layout/Projects.vue'
			import ProjectsIndex from '../components/projects/projects/views/Index.vue'
			import ProjectsEdit from '../components/projects/projects/views/Edit.vue'
			import ProjectsShow from '../components/projects/projects/views/Show.vue'
			import ProjectsTasks from '../components/projects/projects/views/Tasks.vue'
			import ProjectsCustomers from '../components/projects/projects/views/Customers.vue'
			import ProjectsCalendar from '../components/projects/projects/views/Calendar.vue'
			import ProjectsDocs from '../components/projects/projects/views/Docs.vue'
			import ProjectsIncidents from '../components/projects/projects/views/Incidents.vue'
			import ProjectsComments from '../components/projects/projects/views/Comments.vue'
			import ProjectsBudgets from '../components/projects/projects/views/Budgets.vue'

		//-- Teams
			import Teams from '../components/projects/teams/layout/Teams.vue'
			import TeamsIndex from '../components/projects/teams/views/Index.vue'
			import TeamsEdit from '../components/projects/teams/views/Edit.vue'

		//-- Map
			import Maps from '../components/projects/maps/layout/Maps.vue'
			import MapsIndex from '../components/projects/maps/views/Index.vue'

	//-- GOWIX MANAGEMENT COMPONENTS
		import ManagementPackage from '../components/management/ManagementPackage.vue'
		import DashboardManagement from '../components/management/dashboard/layout/Dashboard.vue'

		//-- Reports
			import ManagementReports from '../components/management/reports/layout/Reports.vue'

		//-- Activity
			import Activity from '../components/management/activity/layout/Activity.vue'

		//-- Billing
			import Billing from '../components/management/billings/layout/Billing.vue'
			import BillingIndex from '../components/management/billings/views/Index.vue'

		//-- Products
			import Products from '../components/management/products/layout/Products.vue'
			import ProductsIndex from '../components/management/products/views/Index.vue'
			import ProductsCreate from '../components/management/products/views/Create.vue'
			import ProductsEdit from '../components/management/products/views/Edit.vue'

		//-- Products Categories
			import ProductCategories from '../components/management/productCategories/layout/ProductCategories.vue'
			import ProductCategoriesIndex from '../components/management/productCategories/views/Index.vue'

		//-- Products Attribute Lists
			import ProductAttributeLists from '../components/management/productAttributeLists/layout/ProductAttributeLists.vue'
			import ProductAttributeListsIndex from '../components/management/productAttributeLists/views/Index.vue'

		//-- Budgets
			import Budgets from '../components/management/budgets/layout/Budgets.vue'
			import BudgetsIndex from '../components/management/budgets/views/Index.vue'
			import BudgetsEdit from '../components/management/budgets/views/Edit.vue'
			import BudgetsShow from '../components/management/budgets/views/Show.vue'
			import BudgetsDocs from '../components/management/budgets/views/Docs.vue'
			import BudgetsViewer from '../components/management/budgets/views/Viewer.vue'

		//-- Orders
			import Orders from '../components/management/orders/layout/Orders.vue'
			import OrdersIndex from '../components/management/orders/views/Index.vue'
			import OrdersEdit from '../components/management/orders/views/Edit.vue'
			import OrdersShow from '../components/management/orders/views/Show.vue'
			import OrdersDeliveryNotes from '../components/management/orders/views/DeliveryNotes.vue'

		//-- Delivery Note
			import DeliveryNotes from '../components/management/deliveryNotes/layout/DeliveryNotes.vue'
			import DeliveryNotesIndex from '../components/management/deliveryNotes/views/Index.vue'
			import DeliveryNotesEdit from '../components/management/deliveryNotes/views/Edit.vue'
			import DeliveryNotesShow from '../components/management/deliveryNotes/views/Show.vue'

		//-- Invoices
			import Invoices from '../components/management/invoices/layout/Invoices.vue'
			import InvoicesIndex from '../components/management/invoices/views/Index.vue'
			import InvoicesEdit from '../components/management/invoices/views/Edit.vue'
			import InvoicesShow from '../components/management/invoices/views/Show.vue'

		//-- Providers
			import Providers from '../components/management/providers/layout/Providers.vue'
			import ProvidersIndex from '../components/management/providers/views/Index.vue'
			import ProvidersCreate from '../components/management/providers/views/Create.vue'
			import ProvidersEdit from '../components/management/providers/views/Edit.vue'
			import ProvidersShow from '../components/management/providers/views/Show.vue'

		//-- Collection Accounts
			import Accounts from '../components/management/accounts/layout/Accounts.vue'
			import AccountsIndex from '../components/management/accounts/views/Index.vue'

	//-- GOWIX CMS COMPONENTS
		import CmsPackage from '../components/cms/CmsPackage.vue'
		import DashboardCms from '../components/cms/dashboard/layout/Dashboard.vue'

		//-- Categories
			import Category from '../components/cms/categories/layout/Category.vue'
			import CategoryIndex from '../components/cms/categories/views/Index.vue'
			import CategoryEdit from '../components/cms/categories/views/Edit.vue'
		//-- Articles
			import Article from '../components/cms/articles/layout/Article.vue'
			import ArticleIndex from '../components/cms/articles/views/Index.vue'
			import ArticleEdit from '../components/cms/articles/views/Edit.vue'

	//-- PUBLIC COMPONENTS
		import BudgetViewer from '../components/public/management/budgets/views/BudgetViewer.vue'
		import InvoiceViewer from '../components/public/management/invoices/views/InvoiceViewer.vue'
		import AgreementViewer from '../components/public/agreements/views/AgreementViewer.vue'
		import DeliveryNoteViewer from '../components/public/management/deliverynotes/views/DeliveryNoteViewer.vue'

Vue.use(Router)

const withPrefix = (prefix, routes) =>
	routes.map( (route) => {
		route.path = prefix + route.path
		return route
	})

const routes = [
	{
		path: "/:lang",
		component: Authentication,
		meta: {
			authentication: true,
			title: process.env.APP_NAME + ' - Authentication',
		},
		children: [
			{
				path: "",
				component: Login,
				meta: {
					authentication: true,
					forVisitors: true,
					title: process.env.APP_NAME + ' - Login',
				}
			},
		]
	},
	{
		path: "/:lang/:account",
		component: Authentication,
		meta: {
			authentication: true,
			title: process.env.APP_NAME + ' - Authentication',
		},
		children: [
			{
				path: "",
				component: Login,
				meta: {
					authentication: true,
					forVisitors: true,
					title: process.env.APP_NAME + ' - Login',
				}
			},
		]
	},
	/* ------------------ AUTH ------------------ */
		{
			path: "/:lang/:account/authentication",
			component: Authentication,
			name: 'authentication',
			meta: {
				authentication: true,
				title: process.env.APP_NAME + ' - Authentication',
			},
			children: [
				{
					path: "login",
					component: Login,
					name: 'login',
					meta: {
						authentication: true,
						forVisitors: true,
						title: process.env.APP_NAME + ' - Login',
					}
				},
				{
					path: "logout",
					component: Logout,
					name: 'logout',
					meta: {
						authentication: true,
						forAuth: true,
						title: process.env.APP_NAME + ' - Logout',
					}
				},
				{
					path: "forget/password",
					component: Forget,
					name: 'forget-password',
					meta: {
						authentication: true,
						forVisitors: true,
						title: process.env.APP_NAME + ' - Password forget',
					}
				},
				{
					path: "reset/password/:token",
					component: Reset,
					name: 'reset-password',
					meta: {
						authentication: true,
						forVisitors: true,
						title: process.env.APP_NAME + ' - Password reset',
					}
				},
				{
					path: "activation/:activation",
					component: Login,
					name: 'activation',
					meta: {
						authentication: true,
						forVisitors: true,
						title: process.env.APP_NAME + ' - Password activation',
					}
				},
			]
		},
	/* ------------------ PUBLIC ------------------ */
		{
			path: "/:lang/:account/management/budgets/:random",
			component: BudgetViewer,
			meta: {
				forAuth: false,
				title: process.env.APP_NAME + ' - Budget viewer',
			},
		},
		{
			path: "/:lang/:account/management/invoices/:random",
			component: InvoiceViewer,
			meta: {
				forAuth: false,
				title: process.env.APP_NAME + ' - Invoice viewer',
			},
		},
		{
			path: "/:lang/:account/management/deliverynotes/:random",
			component: DeliveryNoteViewer,
			meta: {
				forAuth: false,
				title: process.env.APP_NAME + ' - Delivery note viewer',
			},
		},
		{
			path: "/:lang/:account/agreements/:random",
			component: AgreementViewer,
			meta: {
				forAuth: false,
				title: process.env.APP_NAME + ' - Agreement viewer',
			},
		},
	/* ------------------ ADMIN ------------------ */
		{
			path: "/:lang/:account/admin",
			component: Admin,
			meta: {
				menu: 'dashboard',
				forAuth: true,
				title: process.env.APP_NAME + ' - Admin',
			},
			children: [
				{
					path: "",
					component: Dashboard,
					meta: {
						menu: 'dashboard',
						forAuth: true,
						title: process.env.APP_NAME + ' - Dashboard',
					}
				},
				{
					path: "dashboard",
					component: Dashboard,
					meta: {
						menu: 'dashboard',
						forAuth: true,
						title: process.env.APP_NAME + ' - Dashboard',
					}
				},
				{
					path: "settings",
					component: Settings,
					meta: {
						menu: 'dashboard',
						forAuth: true,
						title: process.env.APP_NAME + ' - Settings',
					},
					children: [
						{
							path: "",
							component: SettingsIndex,
							meta: {
								menu: 'dashboard',
								forAuth: true,
								title: process.env.APP_NAME + ' - Settings',
							},
						},
						{
							path: "paymentconditions",
							component: PaymentConditions,
							meta: {
								menu: 'dashboard',
								forAuth: true,
								title: process.env.APP_NAME + ' - Payment conditions',
							},
							children: [
								{
									path: "",
									component: PaymentConditionsIndex,
									meta: {
										menu: 'dashboard',
										forAuth: true,
										title: process.env.APP_NAME + ' - Payment conditions',
									}
								},
							],
						},
					],
				},
				{
					path: "qr-reader",
					component: qrCodeReader,
					meta: {
						menu: 'dashboard',
						forAuth: true,
						title: process.env.APP_NAME + ' - QR Code Reader',
					}
				},
				/* ------------------ USERS ------------------ */
					{
						path: "users",
						component: Users,
						meta: {
							menu: 'dashboard',
							forAuth: true,
							title: process.env.APP_NAME + ' - Users',
						},
						children: [
							{
								path: "/",
								component: UsersIndex,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Users',
								}
							},
							{
								path: "create",
								component: UsersCreate,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - New user',
								}
							},
							{
								path: ":id/edit",
								component: UsersEdit,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Edit user'
								}
							},
							{
								path: ":id",
								component: UsersShow,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - User profile'
								}
							},
						]
					},
				/* ------------------ REQUESTS ------------------ */
					{
						path: "requests",
						component: Requests,
						meta: {
							menu: 'dashboard',
							breadcrumb: 'requests',
							forAuth: true,
							title: process.env.APP_NAME + ' - Requests',
						},
						children: [
							{
								path: "/",
								component: RequestsIndex,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Requests',
								}
							},
						]
					},
				/* ------------------ CUSTOMERS ------------------ */
					{
						path: "customers",
						component: Customers,
						meta: {
							menu: 'dashboard',
							breadcrumb: 'customers',
							forAuth: true,
							title: process.env.APP_NAME + ' - Customers',
						},
						children: [
							{
								path: "/",
								component: CustomersIndex,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customers',
								}
							},
							{
								path: "create",
								component: CustomersCreate,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - New customers',
								}
							},
							{
								path: ":id/edit",
								component: CustomersEdit,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Edit customer'
								}
							},
							{
								path: ":id",
								component: CustomersShow,
								meta: {
									name: 'show',
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Show customer'
								}
							},
							{
								path: ":id/budgets",
								component: CustomersBudgets,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer budgets'
								}
							},
							{
								path: ":id/accounts",
								component: CustomersAccounts,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer accounts'
								}
							},
							{
								path: ":id/orders",
								component: CustomersOrders,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer orders'
								}
							},
							{
								path: ":id/invoices",
								component: CustomersInvoices,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer invoices'
								}
							},
							{
								path: ":id/projects",
								component: CustomersProjects,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer projects'
								}
							},
							{
								path: ":id/agreements",
								component: CustomersAgreements,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer agreements'
								}
							},
							{
								path: ":id/docs",
								component: CustomersDocs,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer docs'
								}
							},
							{
								path: ":id/requests",
								component: CustomersRequests,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer requests'
								}
							},
							{
								path: ":id/docs/:media_id/viewer",
								component: CustomersViewer,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Customer viewer'
								}
							},
							{
								path: ":id/billings",
								component: Billing,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Billings'
								},
								children: [
									{
										path: "",
										component: BillingIndex,
										meta: {
											menu: 'dashboard',
											forAuth: true,
											title: process.env.APP_NAME + ' - Index Billings',
										}
									},
								],
							},
						]
					},
				/* ------------------ DEPARTMENTS ------------------ */
					{
						path: "departments",
						component: Departments,
						meta: {
							menu: 'dashboard',
							forAuth: true,
							title: process.env.APP_NAME + ' - Departments'
						},
						children: [
							{
								path: "/",
								component: DepartmentsIndex,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Departments'
								}
							},
						]
					},
				/* ------------------ NOTIFICATIONS ------------------ */
					{
						path: "notifications",
						component: Notifications,
						meta: {
							menu: 'dashboard',
							forAuth: true,
							title: process.env.APP_NAME + ' - Notifications'
						},
						children: [
							{
								path: "/",
								component: NotificationsIndex,
								meta: {
									menu: 'dashboard',
									forAuth: true,
									title: process.env.APP_NAME + ' - Notifications'
								}
							},
						]
					},
				/* ------------------ GOWIX PROJECTS ------------------ */
					{
						path: "projects",
						component: ProjectsPackage,
						meta: {
							menu: 'projects',
							forAuth: true,
							title: process.env.APP_NAME + ' - Dashboard',
						},
						children: [
							{
								path: "",
								component: DashboardProjects,
								meta: {
									menu: 'projects',
									forAuth: true,
									title: process.env.APP_NAME + ' Gestión de proyectos',
								}
							},
							/* ------------------ CALENDAR ------------------ */
								{
									path: "calendar",
									component: Calendar,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Calendar',
									},
									children: [
										{
											path: "/",
											component: CalendarIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Calendar',
											},
										},
									]
								},
							/* ------------------ USERS ------------------ */
								{
									path: "users",
									component: Users,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Users',
									},
									children: [
										{
											path: "/",
											component: UsersIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Users',
											}
										},
										{
											path: "create",
											component: UsersCreate,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - New user',
											}
										},
										{
											path: ":id/edit",
											component: UsersEdit,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit user'
											}
										},
										{
											path: ":id",
											component: UsersShow,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - User profile'
											}
										},
									]
								},
						/* ------------------ REQUESTS ------------------ */
							{
								path: "requests",
								component: Requests,
								meta: {
									menu: 'projects',
									breadcrumb: 'requests',
									forAuth: true,
									title: process.env.APP_NAME + ' - Requests',
								},
								children: [
									{
										path: "/",
										component: RequestsIndex,
										meta: {
											menu: 'projects',
											forAuth: true,
											title: process.env.APP_NAME + ' - Requests',
										}
									},
								]
							},
							/* ------------------ CUSTOMERS ------------------ */
								{
									path: "customers",
									component: Customers,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Customers',
									},
									children: [
										{
											path: "/",
											component: CustomersIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customers',
											}
										},
										{
											path: "create",
											component: CustomersCreate,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - New customers',
											}
										},
										{
											path: ":id/edit",
											component: CustomersEdit,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit customer'
											}
										},
										{
											path: ":id",
											component: CustomersShow,
											meta: {
												name: 'show',
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show customer'
											}
										},
										{
											path: ":id/budgets",
											component: CustomersBudgets,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer budgets'
											}
										},
										{
											path: ":id/accounts",
											component: CustomersAccounts,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer accounts'
											}
										},
										{
											path: ":id/orders",
											component: CustomersOrders,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer orders'
											}
										},
										{
											path: ":id/invoices",
											component: CustomersInvoices,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer invoices'
											}
										},
										{
											path: ":id/projects",
											component: CustomersProjects,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer projects'
											}
										},
										{
											path: ":id/agreements",
											component: CustomersAgreements,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer agreements'
											}
										},
										{
											path: ":id/docs",
											component: CustomersDocs,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer docs'
											}
										},
										{
											path: ":id/requests",
											component: CustomersRequests,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer requests'
											}
										},
										{
											path: ":id/docs/:media_id/viewer",
											component: CustomersViewer,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer viewer'
											}
										},
										{
											path: ":id/billings",
											component: Billing,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Billings'
											},
											children: [
												{
													path: "",
													component: BillingIndex,
													meta: {
														menu: 'projects',
														forAuth: true,
														title: process.env.APP_NAME + ' - Index Billings',
													}
												},
											],
										},
									]
								},
							/* ------------------ DEPARTMENTS ------------------ */
								{
									path: "departments",
									component: Departments,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Departments'
									},
									children: [
										{
											path: "/",
											component: DepartmentsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Departments'
											}
										},
									]
								},
							/* ------------------ TASKS ------------------ */
								{
									path: "tasks",
									component: Tasks,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Tasks',
									},
									children: [
										{
											path: "/",
											component: TasksIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Tasks',
											}
										},
										{
											path: "create",
											component: TasksCreate,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Create task',
											}
										},
										{
											path: ":id/edit",
											component: TasksEdit,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit task',
											}
										},
										{
											path: ":id",
											component: TasksShow,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show task',
											}
										},
										{
											path: "status/:status",
											component: TasksIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Tasks',
											}
										},
									]
								},
							/* ------------------ REPORTS ------------------ */
								{
									path: "reports",
									component: ProjectsReports,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Reports',
									}
								},
							/* ------------------ PROJECTS ------------------ */
								{
									path: "projects",
									component: Projects,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Projects',
									},
									children: [
										{
											path: "/",
											name: 'ProjectsIndex',
											component: ProjectsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Projects',
											},
										},
										{
											path: ":id/edit",
											name: "ProjectsEdit",
											component: ProjectsEdit,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit project',
											}
										},
										{
											path: ":id",
											name: "ProjectsShow",
											component: ProjectsShow,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show project'
											}
										},
										{
											path: ":id/tasks",
											component: ProjectsTasks,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project tasks'
											}
										},
										{
											path: ":id/customers",
											component: ProjectsCustomers,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project customers'
											}
										},
										{
											path: ":id/docs",
											component: ProjectsDocs,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project docs'
											}
										},
										{
											path: ":id/incidents",
											component: ProjectsIncidents,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project incidents'
											}
										},
										{
											path: ":id/comments",
											component: ProjectsComments,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project comments'
											}
										},
										{
											path: ":id/budgets",
											component: ProjectsBudgets,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project budgets'
											}
										},
										{
											path: ":id/calendar",
											component: ProjectsCalendar,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Project calendar'
											}
										},
										{
											path: "status/:status",
											name: 'Estado',
											component: ProjectsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Projects',
											}
										},
									]
								},
							/* ------------------ TEAMS ------------------ */
								{
									path: "teams",
									component: Teams,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Teams',
									},
									children: [
										{
											path: "/",
											component: TeamsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Teams',
											},
										},
										{
											path: ":id/edit",
											component: TeamsEdit,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit team',
											}
										},
									]
								},
							/* ------------------ MAP ------------------ */
								{
									path: "maps",
									component: Maps,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Maps',
									},
									children: [
										{
											path: "/",
											component: MapsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Maps',
											},
										},
									]
								},
							/* ------------------ SETTINGS ------------------ */
								{
									path: "settings",
									component: Settings,
									meta: {
										menu: 'projects',
										forAuth: true,
										title: process.env.APP_NAME + ' - Settings',
									},
									children: [
										{
											path: "",
											component: SettingsIndex,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Settings',
											},
										},
										{
											path: "paymentconditions",
											component: PaymentConditions,
											meta: {
												menu: 'projects',
												forAuth: true,
												title: process.env.APP_NAME + ' - Payment conditions',
											},
											children: [
												{
													path: "",
													component: PaymentConditionsIndex,
													meta: {
														menu: 'projects',
														forAuth: true,
														title: process.env.APP_NAME + ' - Payment conditions',
													}
												},
											],
										},
									],
								},
						]
					},
				/* ------------------ GOWIX MANAGEMENT ------------------ */
					{
						path: "management",
						component: ManagementPackage,
						meta: {
							menu: 'management',
							forAuth: true,
							title: process.env.APP_NAME + ' - Management',
						},
						children: [
							{
								path: "",
								component: DashboardManagement,
								meta: {
									menu: 'management',
									forAuth: true,
									title: process.env.APP_NAME + ' Gestión online',
								}
							},
							/* ------------------ REPORTS ------------------ */
								{
									path: "reports",
									component: ManagementReports,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Reports',
									}
								},
							/* ------------------ ACTIVUTY ------------------ */
								{
									path: "activity",
									component: Activity,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Activity',
									},
								},
							/* ------------------ PRODUCTS ------------------ */
								{
									path: "products",
									component: Products,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Products',
									},
									children: [
										{
											path: "/",
											component: ProductsIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Products',
											},
										},
										{
											path: "create",
											component: ProductsCreate,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Create',
											},
										},
										{
											path: ":id/edit",
											component: ProductsEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
										{
											path: "categories",
											component: ProductCategories,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Products categories',
											},
											children: [
												{
													path: "/",
													component: ProductCategoriesIndex,
													meta: {
														menu: 'management',
														forAuth: true,
														title: process.env.APP_NAME + ' - Products categories',
													},
												},
											]
										},
										{
											path: "attributes",
											component: ProductAttributeLists,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Products attribute lists',
											},
											children: [
												{
													path: "/",
													component: ProductAttributeListsIndex,
													meta: {
														menu: 'management',
														forAuth: true,
														title: process.env.APP_NAME + ' - Products attribute lists',
													},
												},
											]
										},
									]
								},
							/* ------------------ BUDGETS ------------------ */
								{
									path: "budgets",
									component: Budgets,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Budgets',
									},
									children: [
										{
											path: "/",
											component: BudgetsIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Budgets',
											},
										},
										{
											path: ":id",
											component: BudgetsShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show',
											},
										},
										{
											path: ":id/edit",
											component: BudgetsEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
										{
											path: ":id/docs",
											component: BudgetsDocs,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Docs',
											},
										},
										{
											path: ":id/docs/:media_id/viewer",
											component: BudgetsViewer,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Viewer',
											},
										},
									]
								},
							/* ------------------ ORDERS ------------------ */
								{
									path: "orders",
									component: Orders,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Orders',
									},
									children: [
										{
											path: "/",
											component: OrdersIndex,
											meta: {
												name: 'Orders',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Orders',
											},
										},
										{
											path: "customers",
											component: OrdersIndex,
											meta: {
												name: 'Customers orders',
												type: 'customers',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customers orders',
											},
										},
										{
											path: "providers",
											component: OrdersIndex,
											meta: {
												name: 'Providers orders',
												type: 'providers',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Providers orders',
											},
										},
										{
											path: ":id",
											component: OrdersShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show',
											},
										},
										{
											path: ":id/edit",
											component: OrdersEdit,
											meta: {
												name: 'edit',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
										{
											path: ":id/deliverynotes",
											component: OrdersDeliveryNotes,
											meta: {
												name: 'deliverynotes',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Delivery notes',
											},
										},
									]
								},
							/* ------------------ DELIVERY NOTES ------------------ */
								{
									path: "deliverynotes",
									component: DeliveryNotes,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Delivery Notes',
									},
									children: [
										{
											path: "/",
											component: DeliveryNotesIndex,
											meta: {
												name: 'DeliveryNotes',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Delivery Notes',
											},
										},
										{
											path: ":id",
											component: DeliveryNotesShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Delivery Notes Show',
											},
										},
										{
											path: ":id/edit",
											component: DeliveryNotesEdit,
											meta: {
												name: 'edit',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Delivery Notes Edit',
											},
										},
									]
								},
							/* ------------------ INVOICES ------------------ */
								{
									path: "invoices",
									component: Invoices,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Invoices',
									},
									children: [
										{
											path: "/",
											component: InvoicesIndex,
											meta: {
												name: 'Invoices',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Invoices',
											},
										},
										{
											path: "sales",
											component: InvoicesIndex,
											meta: {
												name: 'Sales invoices',
												type: 'sales',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Sales invoices',
											},
										},
										{
											path: "purchases",
											component: InvoicesIndex,
											meta: {
												name: 'Purchases invoices',
												type: 'purchases',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Purchases invoices',
											},
										},
										{
											path: ":id",
											component: InvoicesShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show',
											},
										},
										{
											path: ":id/edit",
											component: InvoicesEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
									]
								},
							/* ------------------ PROVIDERS ------------------ */
								{
									path: "providers",
									component: Providers,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Providers',
									},
									children: [
										{
											path: "/",
											component: ProvidersIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Orders',
											},
										},
										{
											path: "create",
											component: ProvidersCreate,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Create',
											},
										},
										{
											path: ":id",
											component: ProvidersShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show',
											},
										},
										{
											path: ":id/edit",
											component: ProvidersEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
									]
								},
							/* ------------------ COLLECTION ACCOUNTS ------------------ */
								{
									path: "accounts",
									component: Accounts,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Accounts',
									},
									children: [
										{
											path: "/",
											component: AccountsIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Accounts',
											},
										},
									]
								},
							/* ------------------ AGREEMENTS ------------------ */
								{
									path: "agreements",
									component: Agreement,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Contratos',
									},
									children: [
										{
											path: "/",
											component: AgreementIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Contratos',
											},
										},
										{
											path: ":id/edit",
											component: AgreementEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit',
											},
										},
										{
											path: ":id",
											component: AgreementShow,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show',
											},
										},
										{
											path: ":id/recurrings",
											component: Recurrings,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Recurrings',
											},
										},
									]
								},
							/* ------------------ USERS ------------------ */
								{
									path: "users",
									component: Users,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Users',
									},
									children: [
										{
											path: "/",
											component: UsersIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Users',
											}
										},
										{
											path: "create",
											component: UsersCreate,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - New user',
											}
										},
										{
											path: ":id/edit",
											component: UsersEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit user'
											}
										},
										{
											path: ":id",
											component: UsersShow,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - User profile'
											}
										},
									]
								},
						/* ------------------ REQUESTS ------------------ */
							{
								path: "requests",
								component: Requests,
								meta: {
									menu: 'management',
									breadcrumb: 'requests',
									forAuth: true,
									title: process.env.APP_NAME + ' - Requests',
								},
								children: [
									{
										path: "/",
										component: RequestsIndex,
										meta: {
											menu: 'management',
											forAuth: true,
											title: process.env.APP_NAME + ' - Requests',
										}
									},
								]
							},
							/* ------------------ CUSTOMERS ------------------ */
								{
									path: "customers",
									component: Customers,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Customers',
									},
									children: [
										{
											path: "/",
											component: CustomersIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customers',
											}
										},
										{
											path: "create",
											component: CustomersCreate,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - New customers',
											}
										},
										{
											path: ":id/edit",
											component: CustomersEdit,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit customer'
											}
										},
										{
											path: ":id",
											component: CustomersShow,
											meta: {
												name: 'show',
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show customer'
											}
										},
										{
											path: ":id/budgets",
											component: CustomersBudgets,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer budgets'
											}
										},
										{
											path: ":id/accounts",
											component: CustomersAccounts,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer accounts'
											}
										},
										{
											path: ":id/orders",
											component: CustomersOrders,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer orders'
											}
										},
										{
											path: ":id/invoices",
											component: CustomersInvoices,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer invoices'
											}
										},
										{
											path: ":id/projects",
											component: CustomersProjects,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer projects'
											}
										},
										{
											path: ":id/agreements",
											component: CustomersAgreements,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer agreements'
											}
										},
										{
											path: ":id/docs",
											component: CustomersDocs,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer docs'
											}
										},
										{
											path: ":id/requests",
											component: CustomersRequests,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer requests'
											}
										},
										{
											path: ":id/docs/:media_id/viewer",
											component: CustomersViewer,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer viewer'
											}
										},
										{
											path: ":id/billings",
											component: Billing,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Billings'
											},
											children: [
												{
													path: "",
													component: BillingIndex,
													meta: {
														menu: 'management',
														forAuth: true,
														title: process.env.APP_NAME + ' - Index Billings',
													}
												},
											],
										},
									]
								},
							/* ------------------ DEPARTMENTS ------------------ */
								{
									path: "departments",
									component: Departments,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Departments'
									},
									children: [
										{
											path: "/",
											component: DepartmentsIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Departments'
											}
										},
									]
								},
							/* ------------------ SETTINGS ------------------ */
								{
									path: "settings",
									component: Settings,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - Settings',
									},
									children: [
										{
											path: "",
											component: SettingsIndex,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Settings',
											},
										},
										{
											path: "paymentconditions",
											component: PaymentConditions,
											meta: {
												menu: 'management',
												forAuth: true,
												title: process.env.APP_NAME + ' - Payment conditions',
											},
											children: [
												{
													path: "",
													component: PaymentConditionsIndex,
													meta: {
														menu: 'management',
														forAuth: true,
														title: process.env.APP_NAME + ' - Payment conditions',
													}
												},
											],
										},
									],
								},
							/* ------------------ QR CODE READER ------------------ */
								{
									path: "qr-reader",
									component: qrCodeReader,
									meta: {
										menu: 'management',
										forAuth: true,
										title: process.env.APP_NAME + ' - QR Code Reader',
									}
								},
						]
					},
				/* ------------------ GOWIX CMS ------------------ */
					{
						path: "cms",
						component: CmsPackage,
						meta: {
							menu: 'cms',
							forAuth: true,
							title: process.env.APP_NAME + ' - Cms',
						},
						children: [
							{
								path: "",
								component: DashboardCms,
								meta: {
									menu: 'cms',
									forAuth: true,
									title: process.env.APP_NAME + ' Gestor de contenido',
								}
							},
							/* ------------------ USERS ------------------ */
								{
									path: "users",
									component: Users,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Users',
									},
									children: [
										{
											path: "/",
											component: UsersIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Users',
											}
										},
										{
											path: "create",
											component: UsersCreate,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - New user',
											}
										},
										{
											path: ":id/edit",
											component: UsersEdit,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit user'
											}
										},
										{
											path: ":id",
											component: UsersShow,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - User profile'
											}
										},
									]
								},
						/* ------------------ REQUESTS ------------------ */
							{
								path: "requests",
								component: Requests,
								meta: {
									menu: 'cms',
									breadcrumb: 'requests',
									forAuth: true,
									title: process.env.APP_NAME + ' - Requests',
								},
								children: [
									{
										path: "/",
										component: RequestsIndex,
										meta: {
											menu: 'cms',
											forAuth: true,
											title: process.env.APP_NAME + ' - Requests',
										}
									},
								]
							},
							/* ------------------ CUSTOMERS ------------------ */
								{
									path: "customers",
									component: Customers,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Customers',
									},
									children: [
										{
											path: "/",
											component: CustomersIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customers',
											}
										},
										{
											path: "create",
											component: CustomersCreate,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - New customers',
											}
										},
										{
											path: ":id/edit",
											component: CustomersEdit,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit customer'
											}
										},
										{
											path: ":id",
											component: CustomersShow,
											meta: {
												name: 'show',
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Show customer'
											}
										},
										{
											path: ":id/budgets",
											component: CustomersBudgets,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer budgets'
											}
										},
										{
											path: ":id/accounts",
											component: CustomersAccounts,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer accounts'
											}
										},
										{
											path: ":id/orders",
											component: CustomersOrders,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer orders'
											}
										},
										{
											path: ":id/invoices",
											component: CustomersInvoices,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer invoices'
											}
										},
										{
											path: ":id/projects",
											component: CustomersProjects,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer projects'
											}
										},
										{
											path: ":id/agreements",
											component: CustomersAgreements,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer agreements'
											}
										},
										{
											path: ":id/docs",
											component: CustomersDocs,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer docs'
											}
										},
										{
											path: ":id/requests",
											component: CustomersRequests,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer requests'
											}
										},
										{
											path: ":id/docs/:media_id/viewer",
											component: CustomersViewer,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Customer viewer'
											}
										},
										{
											path: ":id/billings",
											component: Billing,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Billings'
											},
											children: [
												{
													path: "",
													component: BillingIndex,
													meta: {
														menu: 'cms',
														forAuth: true,
														title: process.env.APP_NAME + ' - Index Billings',
													}
												},
											],
										},
									]
								},
							/* ------------------ DEPARTMENTS ------------------ */
								{
									path: "departments",
									component: Departments,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Departments'
									},
									children: [
										{
											path: "/",
											component: DepartmentsIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Departments'
											}
										},
									]
								},
							/* ------------------ CATEGORIES ------------------ */
								{
									path: "categories",
									component: Category,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Categories'
									},
									children: [
										{
											path: "/",
											component: CategoryIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Categories'
											}
										},
										{
											path: ":id/edit",
											component: CategoryEdit,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit Category'
											}
										},
									]
								},
							/* ------------------ ARTICLES ------------------ */
								{
									path: "articles",
									component: Article,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Articles'
									},
									children: [
										{
											path: "/",
											component: ArticleIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Articles'
											}
										},
										{
											path: ":id/edit",
											component: ArticleEdit,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Edit Article'
											}
										},
									]
								},
							/* ------------------ SETTINGS ------------------ */
								{
									path: "settings",
									component: Settings,
									meta: {
										menu: 'cms',
										forAuth: true,
										title: process.env.APP_NAME + ' - Settings',
									},
									children: [
										{
											path: "",
											component: SettingsIndex,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Settings',
											},
										},
										{
											path: "paymentconditions",
											component: PaymentConditions,
											meta: {
												menu: 'cms',
												forAuth: true,
												title: process.env.APP_NAME + ' - Payment conditions',
											},
											children: [
												{
													path: "",
													component: PaymentConditionsIndex,
													meta: {
														menu: 'cms',
														forAuth: true,
														title: process.env.APP_NAME + ' - Payment conditions',
													}
												},
											],
										},
									],
								},
						]
					},
			]
		},
]

export default new Router({
	routes: routes,
	linkActiveClass: 'active',
	mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js